import ConsoleApi from "@/consoleapi/consoleApi";
import {AxiosResponse} from "axios";

/**
 *
 */
export default class InvoiceInfo extends ConsoleApi {
    /**
     *
     */
    protected readonly resource = '/invoice-information';

    /**
     * @param accountId
     */
    public get(accountId: string): Promise<AxiosResponse> {
        return this.axios.get(this.requestUri + this.getAccountResource(accountId), {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param userName
     */
    public show(accountId: string, userName: string): Promise<AxiosResponse> {
        return this.axios.get(this.requestUri + this.getAccountResource(accountId) + '/' + userName, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param userName
     * @param name
     * @param nameKana
     * @param email
     * @param emailCc1
     * @param emailCc2
     * @param emailCc3
     * @param postCode
     * @param address
     * @param buildingName
     * @param departmentName
     * @param companyName
     */
    public create(accountId: string, userName: string,
                  name: string, nameKana: string, email: string, emailCc1: string, emailCc2: string, emailCc3: string, postCode: string, address: string, buildingName: string, departmentName: string,companyName: string): Promise<AxiosResponse> {
        return this.axios.post(this.requestUri + this.getAccountResource(accountId), {
            "name": name,
            "name_kana": nameKana,
            "email": email,
            "emailCc1": emailCc1,
            "emailCc2": emailCc2,
            "emailCc3": emailCc3,
            "postcode": postCode,
            "address": address,
            "building_name": buildingName,
            "department_name": departmentName,
            "company_name": companyName
        },{
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param userName
     * @param name
     * @param nameKana
     * @param contactPhoneNumber
     */
    public update(accountId: string, userName: string, name: string, nameKana: string, contactPhoneNumber: string): Promise<AxiosResponse> {
        return this.axios.put(this.requestUri + this.getAccountResource(accountId) + '/' + userName, {
            name: name,
            "name_kana": nameKana,
            "contact_phone_number": contactPhoneNumber,
        },{
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }
}